<template>
<div>
    <b-modal id="employeeFormModal" centered size="xl" no-close-on-backdrop ref="employeeFormModal" :title="$t('employee.form_title')" hide-footer>
        <b-card>
            <div class="custom-search d-flex justify-content-end">
                <b-row>
                    <b-col>
                        <b-button variant="outline-primary" size="sm" class="mr-1" @click.prevent="addOrUpdate">
                            {{$t('others.ok_title')}}
                        </b-button>
                    </b-col>
                </b-row>
            </div>
            <employee-photo-cropper-form :refreshEmployeePhoto="refreshEmployeePhoto" :image="image" :employeeId="this.id" :uploadImage="uploadImage" :employeePhotoCropperForm="employeePhotoCropperForm"></employee-photo-cropper-form>
            <b-form :hidden="hiddenEmployeePhoto">
                <b-row>
                    <b-col>
                        <b-img v-b-tooltip.html :title="$t('employee.change')" style="cursor: pointer;" :src="imageSrc" v-bind="mainProps" onclick="document.getElementById('photoSelect').click()" rounded="circle" alt="Circle image" class="d-inline-block mb-1" />
                    </b-col>
                    <b-col>
                        <input hidden id="photoSelect" type="file" ref="file" @change="uploadImage($event)" accept="image/*" />
                    </b-col>
                </b-row>
            </b-form>
            <b-form>
                <validation-observer ref="simpleRules">
                    <b-row>
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <validation-provider #default="{ errors }" :name="$t('employee.name')" rules="required">
                                    <label>{{ $t('employee.name')  }}</label>
                                    <b-form-input size="sm" v-model="name" rules="required" :placeholder="$t('employee.name')" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <validation-provider #default="{ errors }" :name="$t('employee.surname')" rules="required">
                                    <label>{{ $t('employee.surname')  }}</label>
                                    <b-form-input size="sm" v-model="surname" rules="required" :placeholder="$t('employee.surname')" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <validation-provider #default="{ errors }" :name="$t('employee.email')" rules="required|email">
                                    <label>{{ $t('employee.email')  }}</label>
                                    <b-form-input size="sm" v-model="email" :placeholder="$t('employee.email')" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <validation-provider :name="$t('employee.title')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                                    <label>{{ $t('employee.title')  }}</label>
                                    <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="titleSelect" value-field="id" text-field="name" :options="titleOption" @change="onTitleChange()" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <label for="starting-date-input">{{ $t('employee.starting_date') }}</label>
                                <CustomDatePicker :datePickerValidateOption="1" v-model="startingDate"></CustomDatePicker>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <label for="ending-date-input">{{ $t('employee.ending_date') }}</label>
                                <CustomDatePicker :datePickerValidateOption="0" v-model="endingDate"></CustomDatePicker>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <validation-provider :name="$t('employee.department')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                                    <label>{{ $t('employee.department')  }}</label>
                                    <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="departmentSelect" value-field="id" text-field="name" :options="departmentOption" @change="onDepartmentChange()" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <validation-provider :name="$t('employee.role')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                                    <label>{{ $t('employee.role')  }}</label>
                                    <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="roleSelect" value-field="id" text-field="name" :options="roleOption" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <validation-provider :name="$t('employee.position')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                                    <label>{{ $t('employee.position')  }}</label>
                                    <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="positionSelect" value-field="id" text-field="name" :options="positionOption" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-lg-3 mt-1">
                            <label for="employees-birth-date-input">{{ $t('employee.birth_date') }}</label>
                            <CustomDatePicker :datePickerValidateOption="0" id="employees-birth-date-input" v-model="dateOfBirth"></CustomDatePicker>
                        </b-col>
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <validation-provider :name="$t('employee.annual_leave_right')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                                    <label>{{ $t('employee.annual_leave_right')  }}</label>
                                    <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="annualLeaveRightSelect" value-field="id" text-field="explanation" :options="annualLeaveRightOption" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <validation-provider :name="$t('employee.company')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                                    <label>{{ $t('employee.company')  }}</label>
                                    <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="companySelect" value-field="id" text-field="name" :options="companyOption" @change="onTitleChange()" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row :hidden="hiddenPermissionSelect">
                        <b-col :hidden="hiddenPermissionSelect" class="col-lg-3 mt-1">
                            <b-form-group>
                                <label>{{ $t('employee.permission_template')  }}</label>
                                <b-form-select size="sm" v-model="permissionTemplateSelect" value-field="id" text-field="name" :options="permissionTemplateOption" />
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row v-if="this.lawCheck">
                        <b-col class="col-md-3 mt-1">
                            <b-form>
                                <validation-provider #default="{ errors }" :name="$t('employee.lawyer_no')" rules="required">
                                    <label for="employees-lawyer-no-input">{{ $t('employee.lawyer_no') }}</label>
                                    <b-form-group>
                                        <b-form-input id="employees-lawyer-no-input" v-model="lawyerNo" maxlength="250" size="sm" rules="required" />
                                        <small class="text-danger">{{ errors[0]  }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </b-form>
                        </b-col>
                        <b-col class="col-md-3 mt-1">
                            <validation-provider #default="{ errors }" :name="$t('employee.lawyer_year')" rules="required">
                                <label for="employees-lawyer-year-date-input">{{ $t('employee.lawyer_year') }}</label>
                                <b-form-group>
                                    <b-form-input id="employees-lawyer-year-date-input" v-model="lawyerYear" type="number" maxlength="4" size="sm" rules="required" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row v-if="this.attorneyCheck">
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <validation-provider :name="$t('employee.attorneyship_type')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                                    <label>{{ $t('employee.attorneyship_type')  }}</label>
                                    <b-form-select size="sm" v-model="powerOfAttorneyshipTypeSelect" value-field="id" text-field="name" :options="powerOfAttorneyshipTypeOption" :state="errors.length > 0 ? false : null" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                        <b-col class="col-md-3 mt-1">
                            <b-form>
                                <validation-provider #default="{ errors }" :name="$t('employee.attorneyship_no')" rules="required">
                                    <label for="employees-attorneyship-no-input">{{ $t('employee.attorneyship_no') }}</label>
                                    <b-form-group>
                                        <b-form-input id="employees-attorneyship-no-input" v-model="powerOfAttorneyNo" maxlength="50" size="sm" rules="required" />
                                        <small class="text-danger">{{ errors[0]  }}</small>
                                    </b-form-group>
                                </validation-provider>
                            </b-form>
                        </b-col>
                        <b-col class="col-md-3 mt-1">
                            <validation-provider #default="{ errors }" :name="$t('employee.attorneyship_registery_date')" rules="required">
                                <label for="employees-attorneyship-registery-date-input">{{ $t('employee.attorneyship_registery_date') }}</label>
                                <b-form-group>
                                    <b-form-input id="employees-attorneyship-registery-date-input" v-model="powerOfAttorneyYear" type="number" maxlength="4" size="sm" rules="required" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </b-form-group>
                            </validation-provider>
                        </b-col>
                    </b-row>
                    <b-row v-if="this.departmentSelect > 0">
                        <b-col class="col-lg-3 mt-1">
                            <b-form-group>
                                <validation-provider :name="$t('employee.sub_department')" :rules="{ excluded: 0 }" v-slot="{ errors }">
                                    <label>{{ $t('employee.sub_department')  }}</label>
                                    <b-form-select size="sm" :state="errors.length > 0 ? false : null" v-model="subDepartmentSelect" value-field="id" text-field="name" :options="subDepartmentOption" />
                                    <small class="text-danger">{{ errors[0]  }}</small>
                                </validation-provider>
                            </b-form-group>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-md-2 mt-1">
                            <label for="employees-is-law-input">{{ $t('employee.is_law') }}</label>
                            <br>
                            <b-form-checkbox class="custom-control-success" name="employees-is-law-input" id="employees-is-law-input" v-model="isLaw" switch>
                                <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                </span>
                                <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                </span>
                            </b-form-checkbox>
                        </b-col>
                        <b-col class="col-md-2 mt-1">
                            <label for="employees-is-legal-definitions-menu-visible-input">{{ $t('employee.is_legal_definitions_menu_visible') }}</label>
                            <br>
                            <b-form-checkbox class="custom-control-success" name="employees-is-legal-definitions-menu-visible-input" id="employees-is-legal-definitions-menu-visible-input" v-model="isLegalDefinitionsMenuVisible" switch>
                                <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                </span>
                                <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                </span>
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                    <b-row>
                        <b-col class="col-md-2 mt-1">
                            <label for="employees-is-2faa-active-input">{{ $t('employee.is_2FAA_Active') }}</label>
                            <br>
                            <b-form-checkbox class="custom-control-success" name="employees-is-2faa-active-input" id="employees-is-2faa-active-input" v-model="is2FAActive" switch>
                                <span class="switch-icon-left">
                                    <feather-icon icon="CheckIcon" />
                                </span>
                                <span class="switch-icon-right">
                                    <feather-icon icon="XIcon" />
                                </span>
                            </b-form-checkbox>
                        </b-col>
                    </b-row>
                </validation-observer>
            </b-form>
        </b-card>
        <b-card :hidden="hiddenEmployeeControl">
            <b-form>
                <b-row>
                    <b-col class="mt-2">
                        <b-tabs pills vertical nav-wrapper-class="nav-vertical">
                            <b-tab :title=" $t('employee.permission')" active style="width:100%;">
                                <b-card-text>
                                    <employee-permission-table-form ref="employeePermissionTableForm" :employeeId="this.id"></employee-permission-table-form>
                                </b-card-text>
                            </b-tab>
                            <!-- <b-tab :title=" $t('employee.price_list')" style="width:100%;">
                                <b-card-text>
                                    <employee-price-list :employeeId="this.id"></employee-price-list>
                                </b-card-text>
                            </b-tab> -->
                            <b-tab :title=" $t('employee.note_permission')" style="width:100%;">
                                <b-card-text>
                                    <employee-note-list :employeeId="this.id"></employee-note-list>
                                </b-card-text>
                            </b-tab>
                            <!-- <b-tab :title=" $t('employee.employment_contract')" style="width:100%;">
                                <b-card-text>
                                    <employee-contract-list :employeeId="this.id"></employee-contract-list>
                                </b-card-text>
                            </b-tab> -->
                            <!-- <b-tab :title=" $t('employee.hourly_annual_leave')" style="width:100%;">
                                <b-card-text>
                                    <hourly-annual-leave-employee-list :employeeId="this.id"></hourly-annual-leave-employee-list>
                                </b-card-text>
                            </b-tab> -->
                            <!-- <b-tab :title=" $t('employee.overtime_work')" style="width:100%;">
                                <b-card-text>
                                    <overtime-work-list-for-employee :employeeId="this.id"></overtime-work-list-for-employee>
                                </b-card-text>
                            </b-tab> -->
                            <!-- <b-tab :title=" $t('employee.annual_leave')" style="width:100%;">
                                <b-card-text>
                                    <employee-annual-leave-list :employeeId="this.id"></employee-annual-leave-list>
                                </b-card-text>
                            </b-tab> -->
                            <b-tab :title=" $t('employee.address')" style="width:100%;">
                                <b-card-text>
                                    <employee-address-list ref="employeeAddressForm" :employeeId="this.id"></employee-address-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title=" $t('employee.education_information')" style="width:100%;">
                                <b-card-text>
                                    <employee-educationInformation-list ref="employeeEducationInformation" :employeeId="this.id"></employee-educationInformation-list>
                                </b-card-text>
                            </b-tab>
                            <!-- <b-tab :title=" $t('employee.power_of_attorney')" style="width:100%;">
                                <b-card-text>
                                    <employee-powerOfAttorney-list ref="employeepowerOfAttorney" :employeeId="this.id"></employee-powerOfAttorney-list>
                                </b-card-text>
                            </b-tab> -->
                            <b-tab :title=" $t('employee.contact')" style="width:100%;">
                                <b-card-text>
                                    <employee-contact-list ref="employeeContact" :employeeId="this.id"></employee-contact-list>
                                </b-card-text>
                            </b-tab>
                            <b-tab :title=" $t('employee.language')" style="width:100%;">
                                <b-card-text>
                                    <employee-language-list ref="employeeLanguage" :employeeId="this.id"></employee-language-list>
                                </b-card-text>
                            </b-tab>
                            <!-- <b-tab :title="$t('employee.digital_archive')" style="width:100%;">
                                <b-card-text>
                                    <documents-list :recordId="this.id" :moduleId="17"></documents-list>
                                </b-card-text>
                            </b-tab> -->
                        </b-tabs>
                    </b-col>
                </b-row>
            </b-form>
        </b-card>
    </b-modal>
</div>
</template>

<script>
export default {
    props: {
        getEmployeeList: {
            type: Function
        }
    },
    data() {
        return {
            id: null,
            employeePhotoCropperForm: {},
            hiddenEmployeePhoto: true,
            hiddenPermissionSelect: true,
            hiddenEmployeeControl: true,
            name: '',
            surname: '',
            email: '',
            titleSelect: 0,
            titleOption: [],
            departmentSelect: 0,
            departmentOption: [],
            roleSelect: 0,
            roleOption: [],
            positionSelect: 0,
            positionOption: [],
            permissionTemplateSelect: 0,
            permissionTemplateOption: [],
            endingDate: null,
            startingDate: null,
            dateOfBirth: null,
            imageSrc: '',
            image: null,
            mainProps: {
                blank: false,
                blankColor: '#777',
                width: 75,
                height: 75,
                class: 'm1',
            },
            phoneNumber: 0,
            foreignLanguage: '',
            isTranslatorSelect: 0,
            isTranslatorOption: [],
            languageItTranslates: '',
            isLaw: false,
            lawyerNo: 0,
            lawyerYear: 0,
            personToContactinCaseOfEmergency: '',
            graduatedSchool: '',
            graduatedDepartment: '',
            graduatedYear: '',
            master: false,
            masterDepartment: '',
            annualLeaveRightOption: [],
            annualLeaveRightSelect: 0,
            is2FAActive: false,
            isLegalDefinitionsMenuVisible: false,
            companySelect: 0,
            companyOption: [],
            lawCheck: false,
            attorneyCheck: false,
            powerOfAttorneyNo: '',
            powerOfAttorneyYear: '',
            powerOfAttorneyshipTypeSelect: 0,
            powerOfAttorneyshipTypeOption: [],
            subDepartmentSelect: 0,
            subDepartmentOption: []
        }
    },
    mounted() {
        this.refreshEmployeePhoto()
    },
    methods: {
        onTitleChange() {
            //Title Select 19 is Lawyer
            if (this.titleSelect == 19) {
                this.lawCheck = true;
            } else {
                this.lawCheck = false;
            }
            if (this.titleSelect == 20) {
                this.attorneyCheck = true
            } else {
                this.attorneyCheck = false
            }
        },
        onDepartmentChange() {
            const data = {
                id: this.departmentSelect
            }
            var controller = {
                name: 'SubDepartment',
                actionName: 'GetSubDepartmentListByDepartmentId'
            }
            var payload = {
                data: data,
                controller: controller
            }
            let loader = this.$loading.show()
            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                if (response.data.resultStatus == true) {
                    this.subDepartmentOption = response.data.subDepartmentList
                    this.subDepartmentOption.splice(0, 0, this.$nullSelected("name"))
                } else {
                    this.$WarningAlert(response.data.resultMessage)
                }
                loader.hide()
            })
        },
        clear() {
            this.departmentSelect = 0
            this.roleSelect = 0
            this.permissionTemplateSelect = 0
            this.companySelect = 0
            this.lawCheck = false
            this.titleSelect = 0
            this.subDepartmentSelect = 0
        },
        refreshEmployeePhoto(base64Image) {
            this.imageSrc = 'data:image/png;base64,' + base64Image
        },
        uploadImage(event) {
            this.$refs.employeePhotoCropperForm.showInfo()
            var input = event.target;
            if (input.files && input.files[0]) {
                var reader = new FileReader();
                reader.onload = (e) => {
                    this.image = e.target.result;
                };
                reader.readAsDataURL(input.files[0]);
            }
        },
        async showInfo(id) {
            let loader = this.$loading.show()

            try {
                this.$refs['employeeFormModal'].show()
                this.id = id

                if (this.id == 0) {
                    this.hiddenPermissionSelect = false
                    this.hiddenEmployeePhoto = true
                    this.hiddenEmployeeControl = true
                } else {
                    this.hiddenPermissionSelect = true
                    this.hiddenEmployeePhoto = false
                    this.hiddenEmployeeControl = false
                    this.imageSrc = require('@/assets/images/logoUser.jpeg')
                }
                var data = {
                    id: this.id
                }
                var controller = {
                    name: 'Employee'
                }
                var payload = {
                    data: data,
                    controller: controller
                }

                await this.$store.dispatch('moduleAuth/getInfo', payload).then((response) => {
                    if (response.data.resultStatus == true) {
                        const employee = response.data.employee || {}
                        this.name = employee.name
                        this.surname = employee.surname
                        this.email = employee.email

                        this.titleOption = response.data.titleList || []
                        this.titleOption.splice(0, 0, this.$nullSelected("name"))

                        this.departmentOption = response.data.departmentList || []
                        this.departmentOption.splice(0, 0, this.$nullSelected("name"))

                        this.roleOption = response.data.employeeRoleList || []
                        this.roleOption.splice(0, 0, this.$nullSelected("name"))

                        this.positionOption = response.data.positionList || []
                        this.positionOption.splice(0, 0, this.$nullSelected("name"))

                        this.permissionTemplateOption = response.data.permissionTemplateList || []
                        this.permissionTemplateOption.splice(0, 0, this.$nullSelected("name"))

                        this.startingDate = employee.startingDate
                        this.endingDate = employee.endingDate
                        this.lawyerYear = employee.becomeLawyerYear
                        this.lawyerNo = employee.lawyerRegistryNumber
                        this.isLaw = employee.isLaw
                        this.dateOfBirth = employee.dateOfBirth

                        this.annualLeaveRightOption = response.data.annualLeaveRightList || []
                        this.annualLeaveRightOption.splice(0, 0, this.$nullSelected("explanation"))

                        this.is2FAActive = employee.is2FAActive
                        this.isLegalDefinitionsMenuVisible = employee.isLegalDefinitionsMenuVisible

                        this.companyOption = response.data.companyList || []
                        this.companyOption.splice(0, 0, this.$nullSelected("name"))

                        this.powerOfAttorneyshipTypeOption = response.data.powerOfAttorneyTypeList || []
                        this.powerOfAttorneyshipTypeOption.splice(0, 0, this.$nullSelected("name"))

                        this.powerOfAttorneyYear = employee.powerOfAttorneyYear
                        this.powerOfAttorneyNo = employee.powerOfAttorneyNo
                        this.subDepartmentSelect = employee.subDepartmentId || 0

                        if (employee.powerOfAttorneyTypeId > 0) {
                            this.powerOfAttorneyshipTypeSelect = employee.powerOfAttorneyTypeId
                        } else {
                            this.powerOfAttorneyshipTypeSelect = 0
                        }

                        if (employee.departmentId > 0) {
                            this.departmentSelect = employee.departmentId

                            // 404 hatası verdiği için şimdilik kapalı
                            this.onDepartmentChange()
                        } else {
                            this.departmentSelect = 0
                        }

                        if (employee.titleId > 0) {
                            this.titleSelect = employee.titleId
                        } else {
                            this.titleSelect = 0
                        }

                        if (employee.roleId > 0) {
                            this.roleSelect = employee.roleId
                        } else {
                            this.roleSelect = 0
                        }

                        if (employee.permissionTemplateId > 0) {
                            this.permissionTemplateSelect = employee.permissionTemplateId
                        } else {
                            this.permissionTemplateSelect = 0
                        }

                        if (employee.companyId > 0) {
                            this.companySelect = employee.companyId
                        } else {
                            this.companySelect = 0
                        }

                        if (employee.annualLeaveRightId > 0) {
                            this.annualLeaveRightSelect = employee.annualLeaveRightId
                        } else {
                            this.annualLeaveRightSelect = 0
                        }

                        if (employee.positionId > 0) {
                            this.positionSelect = employee.positionId
                        } else {
                            this.positionSelect = 0
                        }

                        this.onTitleChange()

                        if (this.id > 0) {
                            this.$nextTick(() => {
                                if (this.$refs.employeePermissionTableForm) {
                                    this.$refs.employeePermissionTableForm.showInfoPermission(this.id)
                                }
                            })

                            const data = {
                                id: this.id
                            }
                            controller = {
                                name: 'Employee',
                                actionName: 'DownloadEmployeePhoto'
                            }
                            payload = {
                                data: data,
                                controller: controller
                            }

                            this.$store.dispatch('moduleAuth/customService', payload).then((response) => {
                                if (response.data.resultStatus == true) {
                                    if (response.data.base64 == null) {
                                        this.imageSrc = require('@/assets/images/logoUser.jpeg')
                                    } else {
                                        this.imageSrc = 'data:image/png;base64,' + response.data.base64
                                    }
                                }
                            })
                        }
                    } else {
                        this.$WarningAlert(response.data.resultMessage)
                    }
                })
            } catch (error) {
                console.error(error)
                this.$WarningAlert(response.data.resultMessage)
            } finally {
                loader.hide()
            }
        },
        addOrUpdate() {
            this.$refs.simpleRules.validate().then(success => {
                if (success) {
                    const data = {
                        id: this.id,
                        name: this.name,
                        surname: this.surname,
                        email: this.email,
                        titleId: this.titleSelect,
                        departmentId: this.departmentSelect,
                        roleId: this.roleSelect,
                        positionId: this.positionSelect,
                        permissionTemplateId: this.permissionTemplateSelect,
                        startingDate: this.startingDate,
                        endingDate: this.endingDate,
                        dateOfBirth: this.dateOfBirth,
                        becomeLawyerYear: this.lawyerYear,
                        lawyerRegistryNumber: this.lawyerNo,
                        isLaw: this.isLaw,
                        annualLeaveRightId: this.annualLeaveRightSelect,
                        is2FAActive: this.is2FAActive,
                        isLegalDefinitionsMenuVisible: this.isLegalDefinitionsMenuVisible,
                        companyId: this.companySelect,
                        powerOfAttorneyNo: this.powerOfAttorneyNo,
                        powerOfAttorneyYear: this.powerOfAttorneyYear,
                        powerOfAttorneyTypeId: this.powerOfAttorneyshipTypeSelect,
                        subDepartmentId: this.subDepartmentSelect
                    }
                    const controller = {
                        name: 'Employee'
                    }
                    const payload = {
                        data: data,
                        controller: controller
                    }
                    this.$store.dispatch('moduleAuth/save', payload).then((response) => {
                        if (response.data.resultStatus == true) {
                            this.getEmployeeList()
                            if (this.id == 0) {
                                this.id = response.data.employeeId
                            }

                            if (response.data.employeeId > 0) {
                                this.$refs.employeePermissionTableForm.showInfoPermission(this.id)
                            }
                            this.hiddenEmployeePhoto = false
                            this.hiddenEmployeeControl = false
                            this.hiddenPermissionSelect = true
                            this.$SaveAlert()
                            if (response.data.base64 == null) {
                                this.imageSrc = require('@/assets/images/logoUser.jpeg')
                            }
                        } else {
                            this.$WarningAlert(response.data.resultMessage)
                        }
                    })
                }
            })
        }
    },
}
</script>

<style lang="scss">
[dir=ltr] .modal-header .close {
    margin: -0.4rem -0.4rem -0.8rem auto;
}

[dir] label {
    margin-bottom: 0.2857rem;
    font-weight: bold;
}

.modal .modal-content {
    overflow: visible;
    margin-bottom: auto;
}

[dir] .invalid-tooltip {
    padding: 0.4rem 0.775rem !important;
    margin-top: -1.5rem !important;
    background-color: #ea5455 !important;
    border-radius: 0.358rem !important;
    left: 20px !important
}

.tableSize {
    font-size: 13px !important;
    border-collapse: collapse;
    width: 100%;
    max-width: 100%;
    table-layout: auto;
}

.datepickerStyle {
    max-height: 2.2em;
    font-family: fangsong;
}
</style>
